<lib-add-contact-confirmation-screen [currentUserRole]="profile?.role" [entity]="entity"></lib-add-contact-confirmation-screen>